import axios from 'axios';

const apiFilas = axios.create({
  baseURL: 'https://filas.operadora.app.br/api',
});

export default apiFilas;
